import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { INCIDENCE_TYPES } from 'modules/payroll_bundle/lib/Incidences/Types'
import fieldTranslations from 'modules/payroll_integrations_datev_api/lib/fieldTranslations'

interface Props {
  unsync_fields: string[] | null
  incidenceType: keyof typeof INCIDENCE_TYPES
}

const PartialSync = ({ unsync_fields, incidenceType }: Props) => {
  const message = () => {
    switch (incidenceType) {
      case INCIDENCE_TYPES.hiring:
        return i18n.t('payroll_integrations.incidences.datev_lauds.partial_sync.hiring.message')
      case INCIDENCE_TYPES.contract:
        return i18n.t('payroll_integrations.incidences.datev_lauds.partial_sync.contract.message')
      default:
        return i18n.t(
          'payroll_integrations.incidences.datev_lauds.partial_sync.personal_data.message'
        )
    }
  }

  return (
    <>
      <Box gap="s4" flexDirection="row">
        <Icon.Medium icon="alert-sign" color="tangerine1000" />
        <Text.Header2>
          {i18n.t('payroll_integrations.incidences.datev_lauds.partial_sync.title')}
        </Text.Header2>
      </Box>
      <Box>
        <Text.Normal color="grey1000">{message()}</Text.Normal>
      </Box>
      <Box component="ul" paddingX="s8" gap="s8">
        {unsync_fields?.map((field) => {
          return (
            <Box component="li" key={field}>
              {`• ${fieldTranslations.t(field)}`}
            </Box>
          )
        })}
      </Box>
      <Box>
        <Text.Normal color="grey1000">
          {i18n.t(
            'payroll_integrations.incidences.datev_lauds.partial_sync.partial_sync_foot_note.message'
          )}
        </Text.Normal>
        <Text.Normal color="grey1000">
          {i18n.t(
            'payroll_integrations.incidences.datev_lauds.partial_sync.partial_sync_foot_note.action'
          )}
        </Text.Normal>
      </Box>
    </>
  )
}

export default PartialSync
